import { render } from "./SMAPOYView.vue?vue&type=template&id=4ccab171"
import script from "./SMAPOYView.vue?vue&type=script&lang=js"
export * from "./SMAPOYView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__